"use strict";

class PropertyImportController {

    constructor( $parse, $window, $timeout, $localStorage, $cookies, SSHttpService, SSUtilService, SSConfigService, SSAppService, SSAlertService, OTPService, SSConfirmationService, SSUserService, Upload) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;
        self.$window = $window;
        self.$localStorage = $localStorage;
        self.$cookies = $cookies;

        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.projectDataTypesExcel = [
            'properties',
            'floorplans',
            'stacks',
            'units'
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.getProperty();
    }

    importProjectData() {
        const self = this;

        if (!self.importParams.projectDataExcelFile || !self.importParams.projectDataType || !self.importParams.selectedLanguage) {
            self.SSAlertService.warning('Please select file to import.');
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.parseProjectDataExcel(self.importParams.projectDataExcelFile);
            }
        );
    }

    parseProjectDataExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/'+self.importParams.projectDataType+'/parse'),
            method: 'POST',
            data: {
                import_file: file,
                property_id: self.property.id,
                language: self.importParams.selectedLanguage,
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.filesUploadProgress = 100;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.importData = response.data;
            self._importProjectData();

        }, function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    _importProjectData() {
        const self = this;

        let importUrl = 'sec/developer/import/'+self.importParams.projectDataType;
        let params = {
            property_id: self.property.id,
            language: self.importParams.selectedLanguage,
        };
        params[self.importParams.projectDataType] = self.importData[self.importParams.projectDataType];

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');
            self.updateLocalLanguage();

            self.progressUploadingFiles = false;
            self.showImport = false;
        });
    }

    hasPermission(permission, property_id){
        const self = this;

        if(permission && self.SSUserService.hasPermissionForProperty(permission, property_id)){
            self.permission_code = permission;
            return true;
        }
        
        // Check permission for live projects
        if(self.data.property.status == self.PROPERTY_STATUS_LISTED){
            self.permission_code = 'DMS_PROJ_VW_LIVE_D';
            return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_LIVE_D', property_id);
        }
        // Check permission for draft projects
        else if(self.data.property.status == self.PROPERTY_STATUS_DRAFT
            || self.data.property.status == self.PROPERTY_STATUS_REVIEW
            || self.data.property.status == self.PROPERTY_STATUS_APPROVED
            || self.data.property.status == self.PROPERTY_STATUS_REJECTED){
            self.permission_code = 'DMS_PROJ_VW_DRAFT_D';
            return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_DRAFT_D', property_id);
        }
        // Check permission for archived projects
        else if(self.data.property.status == self.PROPERTY_STATUS_ARCHIVED){
            self.permission_code = 'DMS_PROJ_VW_ARCHIVE';
            return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_ARCHIVE', property_id);
        }
        else{
            self.permission_code = 'Unknown Code. Please contact admin';
            return false;
        }
    }

    // Property --------------------------------------------------------------------------------------------------------
    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        let url = 'sec/developer/properties/' + self.data.property_id;
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.stats = response.data.stats;
            self.typeMaps = response.data.type_map;
            self.unitTypes = response.data.unit_types;
            self.next_otp_no = response.data.next_otp_no;
            self.next_sub_sale_tracking_no = response.data.next_sub_sale_tracking_no;

            let balanceUnits=self.SSAppService.getRemainingUnits(self.property);
            self.sold_units=self.SSAppService.getLaunchedUnits(self.property)-balanceUnits;
            self.propertyPieChart=[{0:
                [{label:"Available Units", value : balanceUnits},
                {label:"Sold Units", value :self.sold_units,}]
            }];
        });
    }

    updateLocalLanguage(){
        const self = this;
        let url = 'language';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.$localStorage['language'] = response.data.language;
            // self.language = SHOWSUITE.data.language;
            self.$cookies.put('language-md5', response.data.md5);
        });
    }

}

PropertyImportController.$inject = [ '$parse', '$window', '$timeout', '$localStorage', '$cookies', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSConfirmationService', 'SSUserService', 'Upload'];
app.controller('PropertyImportController', PropertyImportController);

